import USER_API from 'api/user/v1'
import { reset, startSubmit, stopSubmit } from 'redux-form'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'
import { TRY_START_SESSION } from 'modules/Auth/types'
import { SET_NEW_USER_PASSWORD } from 'modules/User/Security/Password/types'

function* setNewPassword() {
  const { old_password, password } = yield select((state) => state['form']['user/password'].values)

  return yield call(USER_API.setNewPassword, {
    data: {
      old_password,
      password,
      invalidate_sessions: true,
    },
  })
}

function* setNewUserPassword({ meta: { resolve = () => {}, reject = () => {} } = {} }) {
  try {
    yield put(startSubmit('user/password'))

    const { response, error } = yield call(setNewPassword)

    if (response?.data?.token) {
      localStorage.setItem('access_token', response.data.token.access_token)
      localStorage.setItem('refresh_token', response.data.token.refresh_token)
      yield put({ type: TRY_START_SESSION })
      resolve()
    }

    if (error && error.status >= 400) {
      throw error
    }

    yield put(reset('user/password'))
    yield put(
      notificationShow({
        type: 'success',
        message: 'common::notifications.data_success_updated',
      }),
    )
  } catch (error) {
    if (error.errors) {
      const { fields, form } = extractErrors(error.errors)

      if (fields) {
        yield put(stopSubmit('user/password', fields))
      }

      if (form) {
        yield put(
          notificationShow({
            type: 'error',
            message: form,
          }),
        )
      }
    } else {
      yield put(
        notificationShow({
          type: 'error',
          message: 'common::notifications.data_fetch_failed',
        }),
      )
    }
    console.logXHR(error)
  }
  reject()
}

export default function* Sagas() {
  yield takeLatest(SET_NEW_USER_PASSWORD, setNewUserPassword)
}
